module.exports = __webpack_public_path__ + "static/media/preloader.6521d195.gif";